import { render } from "./StatisticalInvoice.vue?vue&type=template&id=51d4f542&scoped=true"
import script from "./StatisticalInvoice.vue?vue&type=script&lang=js"
export * from "./StatisticalInvoice.vue?vue&type=script&lang=js"

import "./StatisticalInvoice.vue?vue&type=style&index=0&id=51d4f542&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d4f542"]])

export default __exports__